<template>
  <div>
    <b-modal
      id="modal-scrollable"
      v-model="$store.state.someVariables.showHistorialPlayer"
      scrollable
      no-close-on-backdrop
      title="Historial"
      size="lg"
      @hidden="resetModal"
      cancel-variant="outline-secondary"
    >
      <modal-pase
        :listCategorias="listCategoriasAdmin"
        :listEquiposTransferir="listEquiposTransferir"
        :player="playerSelected"
        @initDataPase="initDePase"
      ></modal-pase>
      <b-row>
        <b-col cols="12" md="5" style="display:flex; justify-content:end">
          <croppa
            v-model="croppaFoto"
            :width="170"
            :height="200"
            :disabled="true"
            style="border: 1px solid grey"
            placeholder=" Foto jugador"
            placeholder-color="#543338"
            :placeholder-font-size="16"
            canvas-color="transparent"
            :show-remove-button="false"
            remove-button-color="black"
            :show-loading="false"
            :loading-size="50"
            loading-color="#606060"
            :quality="1"
            :initial-image="getProxy(playerSelected.foto_jug)"
          ></croppa>
        </b-col>
        <b-col cols="12" md="4" class="ml-1">
          <croppa
            v-model="croppaCedula"
            :width="290"
            :height="200"
            :disabled="true"
            style="border: 1px solid grey"
            placeholder="Cedula"
            placeholder-color="#543338"
            :placeholder-font-size="16"
            canvas-color="transparent"
            :show-remove-button="false"
            remove-button-color="black"
            :show-loading="true"
            :loading-size="50"
            loading-color="#606060"
            :initial-image="getProxy(playerSelected.foto_cedula)"
          ></croppa>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col md="6">
          <v-select
            ref="refCi"
            id="input-ci-pasaporte"
            :options="listPlayers"
            placeholder="C.I / PASAPORTE *"
            outlined
            taggable
            v-model="playerSelected.ci_pasaporte"
            @search="searchPlayer"
            @input="changePlayer"
            :disabled="disabledObj.buscador"
            :clearable="
              $store.state.someVariables.actionPlayer == UPDATE_DATA_PLAYER
                ? false
                : true
            "
          ></v-select>
        </b-col>
        <b-col md="6">
          <div class="form-label-group">
            <b-form-input
              id="floating-nombres"
              placeholder=" F. ingreso a PLAYGOL "
              :formatter="formatter"
              v-model="playerSelected.fecha_ingreso"
              disabled
            />
            <label for="floating-nombres">F. ingreso a PLAYGOL</label>
          </div>
        </b-col>

        <b-col md="6" class="mt-1">
          <div class="form-label-group">
            <b-form-input
              id="floating-nombres"
              placeholder=" Nombres "
              :formatter="formatter"
              v-model="playerSelected.nombres"
              disabled
            />
            <label for="floating-nombres">Nombres</label>
          </div>
        </b-col>
        <b-col md="6" class="mt-1">
          <div class="form-label-group">
            <b-form-input
              id="floating-apellidos"
              placeholder="Apellidos"
              :formatter="formatter"
              v-model="playerSelected.apellidos"
              disabled
            />
            <label for="floating-apellidos">Apellidos</label>
          </div>
        </b-col>
        <b-col md="6" class="mt-1">
          <div class="form-label-group">
            <b-form-input
              id="floating-nacimiento"
              type="date"
              v-model="playerSelected.fecha_nac"
              disabled
              @input="calculateAge"
            />
            <label for="floating-nacimiento">Fecha de nacimiento *</label>
          </div>
        </b-col>
        <b-col md="6" class="mt-1">
          <div class="form-label-group">
            <b-form-input
              id="floating-edad"
              placeholder="Edad"
              v-model="playerSelected.edad"
              disabled
            />
            <label for="floating-edad">Edad</label>
          </div>
        </b-col>
        <b-col md="12" class="mt-1 mb-1 d-flex justify-content-center">
          <a
            v-if="
              playerSelected.id_jugador != null &&
                (USER().rol === ROLES.SUPER ||
                  USER().rol === ROLES.ADMIN ||
                  USER().rol === ROLES.CALIFICACION)
            "
            @click="showModalPase"
            href="#"
            style="font-size:12px;position: absolute;top: -15px; text-decoration: underline;"
            >Transferir jugador</a
          >
        </b-col>
      </b-row>
      <b-row
        class="border bg-primary"
        style="font-size:13px; color:white;border-radius: 5px 5px 0px 0px"
      >
        <b-col class="p-1" md="2">Campeonato</b-col>
        <b-col class="p-1" md="2">Equipo</b-col>
        <b-col class="p-1" md="1">Categoria</b-col>
        <b-col class="p-1" style="text-align: center;" md="1">#</b-col>
        <b-col class="p-1" md="2">F. Inscripción</b-col>
        <b-col class="p-1" md="2">F. Calificación</b-col>
        <b-col class="p-1" md="1">Estado</b-col>
      </b-row>
      <b-row
        v-for="item in listHistorial"
        :key="item.id"
        class=" border"
        style="font-size:13px"
      >
        <b-col style="padding:13px;" md="2">{{ item.leva }}</b-col>
        <b-col style="padding:13px;" md="2">{{ item.equipo }}</b-col>
        <b-col style="padding:13px;" md="1">{{ item.categoria }}</b-col>
        <b-col style="padding:13px;text-align: center;" md="1">{{
          item.num_camiseta
        }}</b-col>
        <b-col style="padding:13px;" md="2">{{ item.fecha_inscripcion }}</b-col>
        <b-col style="padding:13px;" md="2">{{ item.fecha_calificacion }}</b-col>
        <b-col style="padding:13px;" md="1">{{ item.estado_jug }}</b-col>
      </b-row>
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col class="mt-1">
              <template v-if="!showLoading"> </template>
            </b-col>
          </b-row>
        </div>
      </template>
      <!-- <b-button ref="hola" @click="holaMundo">
        aplasta
      </b-button> -->
    </b-modal>
    <!-- </validation-observer> -->
  </div>
</template>
<script>
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import { required, email } from '@validations'
import vSelect from 'vue-select'
import { heightFade } from '@core/directives/animations'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import {
  // watch,
  // watchEffect,
  computed,
  // reactive,
  ref,
  reactive,
  // onUpdated,
} from '@vue/composition-api'

// import Cleave from 'vue-cleave-component'
import {
  BModal,
  BRow,
  BCol,
  BFormInput,
  // BFormTextarea,
  // BButton,
  VBPopover,
  // VBTooltip,
  //   BForm,
  //   BInputGroup,
  //   BInputGroupPrepend,
} from 'bootstrap-vue'
import apiCall from '../../utils/apiCall'
import ModalPase from '../../views/inscription/PaseModal.vue'
import useInscription from '../../views/inscription/useInscription'

import {
  URL,
  USER,
  ROLES,
  ESTADO_JUGADOR,
  INSERT_DATA_PLAYER,
  // INSERT_DATA_HISTORY_PLAYER,
  UPDATE_DATA_PLAYER,
  URL_PROXY,
} from '../../utils/variables'

const moment = require('moment-timezone')

moment.tz.setDefault('America/Guayaquil')

export default {
  components: {
    BModal,
    BRow,
    BCol,
    // vSelect,
    BFormInput,
    // BFormTextarea,
    vSelect,
    ModalPase,
    // ValidationProvider,
    // ValidationObserver,
    // Cleave,
    // BButton,
    // BForm,
    // BInputGroup,
    // BInputGroupPrepend,
  },
  directives: {
    'b-popover': VBPopover,
    // 'b-tooltip': VBTooltip,
    heightFade,
    Ripple,
  },

  setup() {
    // console.log('setup modal')
    // console.log(props.isAbierto)
    const { getListCategoriasAdmin, listCategoriasAdmin } = useInscription()
    const croppaFoto = ref({})
    const croppaCedula = ref({})
    const listPlayers = ref([])
    const filtered = ref([])
    const listHistorial = ref([])
    const listEquiposTransferir = ref([])
    const { getApi } = apiCall()
    const selectedRadio = ref('active')
    const disabledInputs = ref(false)
    // eslint-disable-next-line
    const isPassportOther = ref(false)
    const showLoading = ref(false)
    const variante = ref('danger')
    const refCi = ref()
    const playerSelected = reactive({
      apellidos: '',
      ci_pasaporte: '',
      direccion: null,
      email: null,
      fecha_nac: '',
      id_disciplina: '',
      id_equipo: '',
      nombres: '',
      num_camiseta: '',
      id_historial: '',
      observaciones: null,
      foto_jug: '',
      telefono: null,
      tipoJugador: '',
      estado_jug: 'inscrito',
      id_jugador: null,
      vacuna: null,
      fecha_ingreso: '',
    })

    const disabledObj = computed(() => {
      const objDisabled = {
        buscador: false,
        nombres: false,
        apellidos: false,
        fechaNacimiento: false,
        direccion: false,
        telefono: false,
        email: false,
        foto: true,
      }

      return objDisabled
    })

    function formatter(value) {
      return value.toUpperCase()
    }
    function setCroppaRefresh() {
      setTimeout(() => {
        croppaFoto.value.refresh()
        croppaCedula.value.refresh()
      }, 100)
    }
    const getProxy = url =>
    // eslint-disable-next-line
      `${URL_PROXY}${encodeURIComponent(
        url,
      )}`
    async function getListEquiposUltimosJugo(idJugador) {
      const path = `ApiInscripciones/getEquiposUltimoJugo/${idJugador}`
      const data = await getApi(URL, path)
      listEquiposTransferir.value = data
    }
    function showModalPase() {
      getListEquiposUltimosJugo(playerSelected.id_jugador)
      store.commit('someVariables/UPDATE_SHOW_PASE_MODAL', true)
    }

    function initPlayer() {
      playerSelected.nombres = ''
      playerSelected.apellidos = ''
      playerSelected.fecha_nac = ''
      playerSelected.foto_jug = null
      playerSelected.foto_cedula = null
      playerSelected.id_jugador = null
      playerSelected.edad = null
      playerSelected.fecha_ingreso = null
      disabledInputs.value = false
      listHistorial.value = []
      playerSelected.ci_pasaporte = null
      playerSelected.tipoJugador = ''
      store.commit('someVariables/UPDATE_ACTION_PLAYER', INSERT_DATA_PLAYER)
      // setCroppaRefresh()
    }
    function resetModal(bvModalEvt) {
      bvModalEvt.preventDefault()
      // emit('recargar', playerSelected.id_equipo)
      listPlayers.value = []
      showLoading.value = false
      initPlayer()
      //       this.$emit('closeModal', false)
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_NEW_PLAYER', false)
      showLoading.value = false
    }

    function calculateAge(date) {
      // const years = moment().diff(date, 'YYYY-MM-DD')
      const diffDuration = moment.duration(moment().diff(date))
      playerSelected.edad = `${diffDuration.years()} años, ${diffDuration.months()} meses, ${diffDuration.days()} dias`
    }
    // const showNewPlayer = computed(() => props.isOpen)
    async function searchPlayer(value) {
      // console.log(value)
      // console.log(playerSelected)
      const action = store.getters['someVariables/getActionPlayer']
      if (action === INSERT_DATA_PLAYER) {
        if (value.length) {
          const path = `ApiInscripciones/getJugadoresCedula/${value}/null`
          const data = await getApi(URL, path)
          // this.listPlayers.value = data.jugadores
          if (data.flag === 'si') {
            listPlayers.value = []
            data.jugadores.forEach(element => {
              const obj = {
                label: `${element.ci_pasaporte}`,
                value: element.id_jugador,
                apellidos: element.apellidos,
                nombres: element.nombres,
                fecha_nac: element.fecha_nac,
                nuevo: element.nuevo,
                edad: element.edad,
                foto_jug: element.foto_jug,
                foto_cedula: element.foto_cedula,
                id_jugador: element.id_jugador || null,
                id_equipo: playerSelected.id_equipo,
                fecha_ingreso: element.fecha_ingreso,
              }
              listPlayers.value.push(obj)
            })
          } else {
            // playerSelected.ci_pasaporte = value
            initPlayer()
          }
        } else {
          // this.listCI = []
          // this.deHistorial=false;
          // console.log("ssss");
        }
      }
      //  trigger a mutation, or dispatch an action
    }
    function desabilitarEnHistorial(obj) {
      obj.nombres = true
      obj.apellidos = true
      obj.direccion = true
      obj.telefono = true
      obj.email = true
      obj.fechaNacimiento = true
    }

    function setearDatosDeHistorial(item) {
      playerSelected.id_jugador = item.id_jugador
      playerSelected.nombres = item.nombres
      playerSelected.apellidos = item.apellidos
      playerSelected.email = item.email
      playerSelected.fecha_nac = item.fecha_nac
      playerSelected.telefono = item.telefono
      playerSelected.direccion = item.direccion
      playerSelected.posicion = item.posicion
      playerSelected.rol = USER().rol
      playerSelected.foto_jug = item.foto_jug
      playerSelected.foto_cedula = item.foto_cedula
      playerSelected.fecha_nac = item.fecha_nac
      playerSelected.tipoJugador = ''
      playerSelected.edad = item.edad
      playerSelected.nuevo = item.nuevo
      playerSelected.estado_jug = 'inscrito'
      playerSelected.fecha_ingreso = item.fecha_ingreso
      console.log(playerSelected)
      disabledInputs.value = true
      desabilitarEnHistorial(disabledObj.value)
      setCroppaRefresh()
    }
    async function getListHistorial(idJugador) {
      const path = `ApiInscripciones/getHistorialGeneral/${idJugador}/${store.getters['someVariables/getTorneoSeleccionado'].id_torneo}`
      const data = await getApi(URL, path)
      console.log(data)
      listHistorial.value = data.historial
    }
    function initDePase() {
      getListHistorial(playerSelected.id_jugador)
    }
    function changePlayer(item) {
      if (item !== null) {
        if (item.id_jugador !== undefined) {
          setearDatosDeHistorial(item)
          getListHistorial(item.id_jugador)
          getListCategoriasAdmin(
            // eslint-disable-next-line
            store.getters['someVariables/getTorneoSeleccionado'].id_torneo
          )
        }
      } else {
        initPlayer()
        setCroppaRefresh()
      }
    }

    return {
      croppaFoto,
      croppaCedula,
      listPlayers,
      searchPlayer,
      filtered,
      changePlayer,
      initPlayer,
      selectedRadio,
      disabledInputs,
      isPassportOther,
      refCi,
      showLoading,
      variante,
      resetModal,
      formatter,
      calculateAge,
      // defineIsClasificado,
      ROLES,
      USER,
      ESTADO_JUGADOR,
      onlyClose,
      disabledObj,
      UPDATE_DATA_PLAYER,
      getListEquiposUltimosJugo,
      listHistorial,
      playerSelected,
      showModalPase,
      listCategoriasAdmin,
      listEquiposTransferir,
      initDePase,
      getProxy,
    }
  },
}
</script>
<style>
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
.inscrito {
  margin: 0px;
  background: #e6e5e2;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
}
.calificado {
  margin-top: 10px;
  background: #84ef96;
  border-radius: 5px;
  padding-left: 5px;
  font-size: 12px;
}
</style>
